import React from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { EXTRA_LARGE_QUERY, MEDIUM_QUERY } from '@src/constants';
import { CardContent } from '@shared/interfaces/CardContent';
import CarouselCard from './CarouselCard/CarouselCard';

interface CarouselProps {
  cards: CardContent[];
  analyticsId?: string;
}

// @todo 'renderIfEmpty' prop, pending design/product direction on empty states

const Carousel: React.FC<CarouselProps> = ({ cards, analyticsId }) => {
  const isExtraLargeWidth = useMediaQuery(EXTRA_LARGE_QUERY);
  const isMediumWidth = useMediaQuery(MEDIUM_QUERY);

  const displayCardsInRow = (!isMediumWidth && cards.length === 2) || !isExtraLargeWidth;

  const carouselClassNames = classnames(displayCardsInRow && 'flex');

  const cardContainerClassNames = (index: number) => {
    return classnames(
      displayCardsInRow && [
        'flex',
        'flex--1	',
        'flexSelf--stretch',
        'width--1/2',
        'padding--y_8',
        index !== 0 && 'margin--left_16',
      ]
    );
  };

  return (
    <div className={carouselClassNames}>
      {cards.map((card, index) => {
        const highlighted = index === 0 && cards.length >= 2;
        return (
          <div key={card.key} className={cardContainerClassNames(index)}>
            <CarouselCard highlighted={highlighted} analyticsId={analyticsId} {...card} />
          </div>
        );
      })}
    </div>
  );
};

export default Carousel;
